import {
  TEntityResponse,
  TEntityListResponse,
  TEventTypeResBody,
  TEventTypeSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TEventsClient = {
  get(id: string): Promise<TEntityResponse<'event-type', TEventTypeResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'event-type', TEventTypeSummaryResBody> | undefined>;
};

function EventsClient(apiClient: TAPIClient): TEventsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'event-type', TEventTypeResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'event-type', TEventTypeResBody>>(`/event-types/${id}`);

      if (data && data.type !== 'event-type') {
        throw new Error('Invalid entity type received, expected: event-type, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'event-type', TEventTypeSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'event-type', TEventTypeSummaryResBody>>(
        `/event-types?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'event-type') {
        throw new Error('Invalid entity type received, expected: event-type, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TEventsClient, EventsClient };
